import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-external-link",
  "use": "icon-external-link-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-external-link\"><path d=\"M4.222 2A2.239 2.239 0 002 4.222v15.556A2.239 2.239 0 004.222 22h15.556A2.239 2.239 0 0022 19.778V12h-2.222v7.778H4.222V4.222H12V2H4.222zm10 0v2.222h3.985L7.88 14.548l1.571 1.57L19.778 5.794v3.985H22V2h-7.778z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol